import { render, staticRenderFns } from "./Detalhe_Plano.vue?vue&type=template&id=649d0708&"
import script from "./Detalhe_Plano.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports